import { useTranslation } from 'react-i18next';
import { useGetRequiredRule, useGetSlugRule, useLengthValidationRule } from '@/hooks';
import { ProductMainInfoFormFieldsNames } from '../helpers/types';

export const useProductDetailsValidationRules = () => {
  const { t } = useTranslation(['validations']);

  const requiredRule = useGetRequiredRule({ t });
  const slugRule = useGetSlugRule({ t });
  const filedLength = useLengthValidationRule({ t, min: 1, max: 10 });

  return {
    [ProductMainInfoFormFieldsNames.LOCALE]: [requiredRule],
    [ProductMainInfoFormFieldsNames.SLUG]: [requiredRule, slugRule],
    [ProductMainInfoFormFieldsNames.EXTERNAL_ID]: [requiredRule],
    [ProductMainInfoFormFieldsNames.UKTZED]: [requiredRule, filedLength],
    [ProductMainInfoFormFieldsNames.IMPORTED]: [requiredRule],
    [ProductMainInfoFormFieldsNames.WEIGHT]: [requiredRule],
    [ProductMainInfoFormFieldsNames.WIDTH]: [requiredRule],
    [ProductMainInfoFormFieldsNames.LENGTH]: [requiredRule],
    [ProductMainInfoFormFieldsNames.HEIGHT]: [requiredRule],
    [ProductMainInfoFormFieldsNames.IS_CUSTOM_ORDER]: [requiredRule],
    [ProductMainInfoFormFieldsNames.UNIT_CODE]: [requiredRule],
  };
};
